<template>
  <div id="app" class="" style="background-color : #f3e8dc;">
    <div>
      <wheelz-header></wheelz-header>
    </div>
    <router-view />
    <div class="flex flex-col items-center" style="clear : both;">
            <img width="250" src="https://fantomwheelz.com/assets/images/fantom_wheelz_minilogo_01.png"
            />
      <hr class="border-4 border-yellow-100" />
    </div>
    <footer class="bg-yellow-400 md:mb-0 mb-8 md:block flex-none p-4">
      <div class="flex flex-row justify-between">
        <div class="pt-3">&copy;2021 Sellek (<a href="https://twitter.com/sellekart/"><i class="fab fa-twitter"></i></a>) and Moose</div>
        <div class="justify-end">
          <a href="https://t.me/fantomwheelz"><i class="mx-1 fa-2x fab fa-telegram"></i></a>
          <a href="https://discord.gg/fwbVXkFbBd"><i class="mx-1 fa-2x fab fa-discord"></i></a>
          <a href="https://twitter.com/fantomwheelz"><i class="mx-1 fa-2x fab fa-twitter"></i></a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import WheelzHeader from '@components/WheelzHeader'

export default {
  name: 'App',
  components: {
    WheelzHeader
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue